export const getStaticMapTileUrl = (lat: number, lng: number, zoom: number = 15): string => {
  const mapScale = Math.pow(2, zoom);
  const tileX = Math.floor(((lng + 180) / 360) * mapScale);
  const tileY = Math.floor(
    (
      (1 - Math.log(Math.tan((lat * Math.PI) / 180) + 1 / Math.cos((lat * Math.PI) / 180)) / Math.PI) /
      2
    ) * mapScale
  );
  const accessToken = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN as string | undefined;
  return `https://api.mapbox.com/styles/v1/mapbox/dark-v11/tiles/256/${zoom}/${tileX}/${tileY}?access_token=${accessToken}`;
};
